import React, { useState, useEffect } from "react";
// import BtmDivider from './svg/BtmDivider';
import BannerImg from "./BannerImg";
import CtaBtn from "./btn/CtaBtn";
// import CloudinaryVideoPlayer from './CloudinaryVideoPlayer';

const Banner = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 767);
      setIsDesktop(window.innerWidth > 767);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

 
    const handleClick = () => {
      const ourStoryElement = document.getElementById('our-story');
  
      if (ourStoryElement) {
        ourStoryElement.scrollIntoView({
          behavior: 'smooth',
        });
      }
    };

  return (
    <>
      <header className="bg-[#FFFBFB] md:h-[80%] w-full">
        <div className="w-full flex flex-col items-center md:flex-row md:justify-between sm:flex-col xl:px-[120px] md:px-[30px] sm:px-[30px]">
          <div className="w-full md:w-1/2 mt-20 flex flex-col gap-5 p-4 md:mt-[100px] justify-center items-center">
            <p className="font-lato leading-7 text-[#12141D] lg:leading-10 text-center md:text-left sm:text-[25px]">
              <strong
                // style={{ fontSize: '2rem' }}
                className="text-[1.5rem] lg:text-[3rem] lg:leading-[60px] xl:text-[2.5rem]   font-black text-center"
              >
                Empower your hospital to run better with{" "}
                <span className="underline text-[#B70303]">
                  safer, quicker, and reliable
                </span>
                <span> medical supplies!</span>
              </strong>
            </p>
            {isMobile && <BannerImg />}
            <p className="text-gray-600 font-bold font-lato tracking-[-0.5px] text-[15px] lg:text-[2rem] xl:text-[1.5rem] text-center lg:text-left md:text-center md:flex md:justify-center lg:flex-none md:text-[24px]">
              Supercharge your hospital's performance with trackable medical
              supplies orders, cost-effective pricing, and unbeatable speed -
              all on one platform.
            </p>

            <div className="flex flex-col lg:flex-row w-full">
              <div className="mb-4">
                <CtaBtn name="Get Started" />
              </div>
              <div className="mx-auto lg:ml-5 lg:mt-4">
                <button className="italic text-[14px] lg:text-[18px] font-lato font-bold text-[#B70303]" onClick={handleClick}>
                  or Learn More
                </button>
              </div>
            </div>
          </div>
          <div className="w-1/2" >{isDesktop && <BannerImg />}</div>
        </div>
      </header>
    </>
  );
};

export default Banner;
